import React from "react";
import { Link } from "react-router-dom";

const CtaLink = ({ ctaText, cta, state, to }) => {
  return (
    <Link to={to ? to : "#"} state={state ?? state} className={cta}>
      {ctaText}
    </Link>
  );
};

export default CtaLink;
